import { type Team } from './records/Team';

export const sortTeams = (a?: Team, b?: Team) => (a && b && a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1);
